import type {GrpcConfig} from '@aboutyou/data-fetcher';
import {
  Country,
  Device,
  Language,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/config.types';
import {
  AnyCountry,
  AnyLanguage,
  Locale,
  getCountry,
  getLanguage,
} from './locale';
import {getVersion} from './version';

export function getGrpcConfig(
  locale: Locale,
  device: 'mobile' | 'desktop',
  abTestGroups?: {
    key: string;
    group: string;
  }[],
): Omit<GrpcConfig, 'traceId'> {
  const country = getCountry(locale);
  const language = getLanguage(locale);

  return {
    country: grpcCountryByHostCountry[country],
    language: grpcLanguageByHostLanguage[language],
    device: device === 'mobile' ? Device.MOBILE_WEB : Device.DESKTOP_WEB,
    clientVersion: getVersion(),
    abTests: abTestGroups || [],
  };
}

const grpcCountryByHostCountry: Record<AnyCountry, Country> = {
  AT: Country.AUSTRIA,
  BE: Country.BELGIUM,
  BG: Country.BULGARIA,
  CH: Country.SWITZERLAND,
  CZ: Country.CZECHIA,
  DE: Country.GERMANY,
  DK: Country.DENMARK,
  EE: Country.ESTONIA,
  ES: Country.SPAIN,
  FI: Country.FINLAND,
  FR: Country.FRANCE,
  GR: Country.GREECE,
  HR: Country.CROATIA,
  HU: Country.HUNGARY,
  IT: Country.ITALY,
  LT: Country.LITHUANIA,
  LV: Country.LATVIA,
  NL: Country.NETHERLANDS,
  PL: Country.POLAND,
  PT: Country.PORTUGAL,
  RO: Country.ROMANIA,
  SE: Country.SWEDEN,
  SI: Country.SLOVENIA,
  SK: Country.SLOVAKIA,
  ZZ: Country.GLOBAL,
  CY: Country.CYPRUS,
  LU: Country.LUXEMBOURG,
};

const grpcLanguageByHostLanguage: Record<AnyLanguage, Language> = {
  de: Language.GERMAN,
  bg: Language.BULGARIAN,
  es: Language.SPANISH,
  fi: Language.FINNISH,
  fr: Language.FRENCH,
  hr: Language.CROATIAN,
  hu: Language.HUNGARIAN,
  it: Language.ITALIAN,
  lt: Language.LITHUANIAN,
  lv: Language.LATVIAN,
  pl: Language.POLISH,
  ro: Language.ROMANIAN,
  sk: Language.SLOVAK,
  sl: Language.SLOVENIAN,
  cs: Language.CZECH,
  da: Language.DANISH,
  en: Language.ENGLISH,
  et: Language.ESTONIAN,
  nl: Language.DUTCH,
  sv: Language.SWEDISH,
  pt: Language.PORTUGUESE,
  el: Language.GREEK,
  ru: Language.RUSSIAN,
};
